import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="ub-auth-shell ub-dark">
      <div className="ub-auth-grid">
        <section className="ub-auth-hero">
          <div className="ub-auth-brand">
            <div className="ub-auth-brand-mark">U</div>
            <div>
              <p className="ub-auth-eyebrow">urblock</p>
              <h1 className="ub-auth-hero-title">Token infrastructure for builders.</h1>
            </div>
          </div>

          <p className="ub-auth-hero-copy">
            Deploy and manage tokens, compliance, vaults, governance, and more — through one API and dashboard, without writing Solidity.
          </p>

          <div className="ub-auth-highlights">
            <div className="ub-auth-highlight">
              <strong>Every primitive</strong>
              <span>Fungible, NFT, soulbound, security tokens, vesting, vaults, multisig, and DeFi building blocks.</span>
            </div>
            <div className="ub-auth-highlight">
              <strong>Connect smart accounts</strong>
              <span>Non-custodial ERC-4337 accounts for your end-users, managed for you.</span>
            </div>
            <div className="ub-auth-highlight">
              <strong>Production ready</strong>
              <span>REST API, TypeScript SDK, webhooks, and gas handling out of the box.</span>
            </div>
          </div>
        </section>

        <section className="ub-auth-panel">
          <div className="ub-modal ub-auth-modal">
            <Outlet />
          </div>
        </section>
      </div>
    </div>
  );
}
